module.exports = __webpack_public_path__ + "static_pc/img/ewm.0967e69f.png";